import React,{useState,useEffect} from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {getListBundleProductV2} from '../../service/productDetailService'
import {responsiveproductpage}  from "../../utils/constant";
import { Item,ItemDefaultV2 } from "../Products/Item";
import "./bundleproduct.css"

const BundleProduct = (sku)=>{
    
    var [dataItems, setdataItems] = useState([]);
      useEffect(()=>{
        let user_id = '';
        if(window.localStorage.getItem('_id')){
          user_id= window.localStorage.getItem('_id');
        }
        try {
            if(sku.sku !== undefined){
              getListBundleProductV2(sku.sku,user_id).then((response) => {
                    if(response !== undefined && response.status === 200){
                        setdataItems(response['message']);
                    }
                    
              });  
            }
        } catch(err) {
          console.error(err);
        }   
      },[sku.sku]
      );
    if(dataItems?.length>0){
    return(
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mgt-20">
        <div className="module so-deals-ltr deal-layout33">
            <div className="head-title">
                <div className="bonus">
                    <span className="head_name">THƯỜNG ĐƯỢC MUA CÙNG</span>
                    <div className="item-time-w">
                        <div className="cslider-item-timer">
                            <div className="product_time_maxprice"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modcontent">
                <div className="so-deal clearfix preset00-5 preset01-4 preset02-3 preset03-2 preset04-1  button-type1  style2">
                    <div className="products-list" >
                    <Carousel data-effect="none" key="product-bundle"
                     responsive={responsiveproductpage}
                    fade={true}
                    >
                        { 
                            dataItems?.map((item, index)=>{
                              return <Item key={index} item={item} index={index}/>
                            })
                        } 
                    </Carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}else{
    return null;
}
}

const BundleProductV1 = (sku)=>{
    var [dataItems, setdataItems] = useState([]);
      useEffect(()=>{
        let user_id = '';
        if(window.localStorage.getItem('_id')){
          user_id= window.localStorage.getItem('_id');
        }
        console.log(user_id);
        try {
            if(sku.sku !== ''){
                getListBundleProductV2(sku.sku,user_id).then((response) => {
                    if(response !== undefined && response.status === 200){
                        setdataItems(response['message']);
                    }
                    
              });  
            }
        } catch(err) {
          console.error(err);
        }   
      },[sku.sku]
      );
    if(dataItems?.length>0){
    return(


        <div className="col-12 p-0">
              <div className="row title m-0 p-0  pt-3">
                <div className="col-6 p-0 m-0 text-start  pb-2"><span className="">Thường được mua cùng</span></div>
              </div>

              <div className="row m-0 p-0 position-relative related-product_list">
                <div className="col-12 p-0 m-0">
                  <div className="mant__item my-auto">
                    <div className="row m-0 position-relative">

                        <Carousel data-effect="none" key="product-bundle"
                        responsive={responsiveproductpage}
                        slidesToSlide={4}
                        fade={true}
                        infinite={true}
                        >
                            { 
                                dataItems?.map((item, index)=>{
                                return <ItemDefaultV2 key={index} item={item} index={index} hotdel="true"/>
                                })
                            } 
                        </Carousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    )
}else{
    return null;
}
}

export {BundleProduct, BundleProductV1}